import "./InsulatedGarageDoorsSydney.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import GarageBenefits from "./sections/GarageBenefits";
import GarageStandards from "./sections/GarageStandards";
import InsulatedRange from "./sections/InsulatedRange";
import GarageWhyUs from "./sections/GarageWhyUs";
import GarageComparison from "./sections/GarageComparison";
import GarageTestimonials from "./sections/GarageTestimonials";
import GarageFaq from "./sections/GarageFaq";
import GarageCta from "./sections/GarageCta";
import GaragePulse from "./sections/GaragePulse";
import SiteFooter from "./sections/SiteFooter";
export default function InsulatedGarageDoorsSydneyPage() {
  return <div>
      <Header />
      <GarageHero />
      <GarageBenefits />
      <GarageStandards />
      <InsulatedRange />
      <GarageWhyUs />
      <GarageComparison />
      <GarageTestimonials />
      <GarageFaq />
      <GaragePulse />
      <GarageCta />
      <SiteFooter />
    </div>;
}